import { Controller } from "stimulus"

export default class extends Controller {
  static values = { pending: Boolean, failed: Boolean }

  connect() {
    if (this.pendingValue || this.failedValue) {
      const delay = this.pendingValue ? 5000 : 300000
      this.timer = setTimeout(() => window.location.reload(), delay)
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
